import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet, apiPost } from "../utils/api_service";
const initialState = {
    vanStockTransfer: [],
    vanStockTransferByDriverAndDate: [],
    vanStockTransferDriver: {},
};
let URL = endpoints.vanStockTransferHeader;
let URLVanDashboard = endpoints.vanDashboard;

const vanStockTransferSlice = createSlice({
    name: "vanStockTransfer",
    initialState,
    reducers: {
        vanStockTransferSuccess: (state = cloneDeep(initialState), action) => {
            const { row } = action.payload;
            return {
                ...state,
                vanStockTransfer: row,
            };
        },

        vanStockTransferByDriverAndDateSuccess: (
            state = cloneDeep(initialState),
            action
        ) => {
            const { row } = action.payload;
            return {
                ...state,
                vanStockTransferByDriverAndDate: row,
            };
        },

        vanStockTransferSuccessNew: (state = cloneDeep(initialState), action) => {
            const { vanStockDataNew } = action.payload;
            return {
                ...state,
                vanStockTransferDriver: vanStockDataNew,
            };
        },

        resetState: (state = cloneDeep(initialState), action) => {
            return {
                ...state,
                ...initialState,
            };
        },
    },
});

export const {
    vanStockTransferSuccess,
    vanStockTransferByDriverAndDateSuccess,
    vanStockTransferSuccessNew,
    resetState,
} = vanStockTransferSlice.actions;

export default vanStockTransferSlice.reducer;

export const getVanStockTransfer = () => async (dispatch) => {
    try {
        const response = apiGet({
            url: URL,
        }).then(({ data, success }) => {
            if (success) {
                const { content } = data.data;
                const row = content.map((projectionData, index) => {
                    let projection = {
                        index: index + 1,
                        id: projectionData.id === null ? "" : projectionData.id,
                        transferNo:
                            projectionData.transferNo === null
                                ? ""
                                : projectionData.transferNo,
                        stockStakeHolder:
                            projectionData.stockStakeHolder === null
                                ? ""
                                : projectionData.stockStakeHolder,
                        stockStakeHolderId:
                            projectionData.stockStakeHolder !== null &&
                                projectionData.stockStakeHolder.id !== null
                                ? projectionData.stockStakeHolder.id
                                : "",
                        stockStakeHolderOwnerName:
                            projectionData.stockStakeHolder !== null &&
                                projectionData.stockStakeHolder.ownerName !== null
                                ? projectionData.stockStakeHolder.ownerName
                                : "",
                        stockStakeHolderFirmName:
                            projectionData.stockStakeHolder !== null &&
                                projectionData.stockStakeHolder.firmName !== null
                                ? projectionData.stockStakeHolder.firmName
                                : "",
                        date: projectionData.date === null ? "" : projectionData.date,
                        vehicleNo:
                            projectionData.vehicle === null
                                ? ""
                                : projectionData.vehicle.vehicleNo,
                        vehicle:
                            projectionData.vehicle === null ? "" : projectionData.vehicle,
                        driver: projectionData.driver === null ? "" : projectionData.driver,
                        driverName:
                            projectionData.driver === null ? "" : projectionData.driver.name,
                        driverId:
                            projectionData.driver !== null &&
                                projectionData.driver.id !== null
                                ? projectionData.driver.id
                                : "",
                        driverContactNo:
                            projectionData.driverContactNo === null
                                ? ""
                                : projectionData.driverContactNo,

                        settleDate:
                            projectionData.settleDate === null
                                ? "-"
                                : projectionData.settleDate,
                        status: projectionData.status === null ? "" : projectionData.status,
                        challanStatus:
                            projectionData.status === null
                                ? ""
                                : projectionData.status == 0
                                    ? "Pending"
                                    : projectionData.status == 1
                                        ? "Received"
                                        : "Cancelled",
                        isSettele:
                            projectionData.isSettele === null ? "" : projectionData.isSettele,
                        isSetteleForTable:
                            projectionData.isSettele === null
                                ? ""
                                : projectionData.isSettele == 1
                                    ? "Settled"
                                    : "Pending",
                        vanStockTransferDetail:
                            projectionData.vanStockTransferDetail === null
                                ? ""
                                : projectionData.vanStockTransferDetail,
                    };
                    return projection;
                });
                dispatch(vanStockTransferSuccess({ row }));
                return { response: row, success };
            }
            return { response: [], success };
        });
        return response;
    } catch (e) {
        return console.error(e.message);
    }
};

export const getVanStockTransferByDriverAndDate =
    ({ fromDate, toDate, driverIdJson }) =>
        async (dispatch) => {
            try {
                const response = apiPost({
                    url:
                        URL +
                        "/by-driver-and-date?fromDate=" +
                        fromDate +
                        "&toDate=" +
                        toDate,
                    postBody: driverIdJson,
                }).then(({ data, success }) => {
                    if (success) {
                        const row = data.data.map((projectionData, index) => {
                            let projection = {
                                index: index + 1,
                                id: projectionData.id === null ? "" : projectionData.id,
                                transferNo:
                                    projectionData.transferNo === null
                                        ? ""
                                        : projectionData.transferNo,
                                stockStakeHolderId:
                                    projectionData.stockStakeHolderId !== null
                                        ? projectionData.stockStakeHolderId
                                        : "",
                                stockStakeHolderOwnerName:
                                    projectionData.ownerName !== null
                                        ? projectionData.ownerName
                                        : "",
                                stockStakeHolderFirmName:
                                    projectionData.firmName !== null
                                        ? projectionData.firmName
                                        : "",
                                date: projectionData.date === null ? "" : projectionData.date,
                                vehicleNo:
                                    projectionData.vehicleNo === null
                                        ? ""
                                        : projectionData.vehicleNo,
                                driverName:
                                    projectionData.driverName === null
                                        ? ""
                                        : projectionData.driverName,
                                driverId:
                                    projectionData.driverId !== null
                                        ? projectionData.driverId
                                        : "",
                                driverContactNo:
                                    projectionData.driverContactNo === null
                                        ? ""
                                        : projectionData.driverContactNo,

                                settleDate:
                                    projectionData.settleDate === null
                                        ? "-"
                                        : projectionData.settleDate,
                                challanStatus:
                                    projectionData.status === null
                                        ? ""
                                        : projectionData.status == 0
                                            ? "Pending"
                                            : projectionData.status == 1
                                                ? "Received"
                                                : projectionData.status == 2 ? "Cancelled" : "Settled",
                                status:
                                    projectionData.status === null ? "" : projectionData.status,
                                isSettele:
                                    projectionData.isSettele === null
                                        ? ""
                                        : projectionData.isSettele,
                                vanStockTransferDetail:
                                    projectionData.vanStockTransferDetail === null
                                        ? ""
                                        : projectionData.vanStockTransferDetail,
                            };
                            return projection;
                        });
                        dispatch(vanStockTransferSuccess({ row }));
                        return { response: row, success };
                    }
                    return { response: [], success };
                });
                return response;
            } catch (e) {
                return console.error(e.message);
            }
        };

export const getVanStockTransferByDriver =
    ({ driverId }) =>
        async (dispatch) => {
            try {
                const response = apiGet({
                    url: URL + "/active-by-driver?driverId=" + driverId,
                }).then(({ data, success }) => {
                    if (success) {
                        let vanStockDataNew = {};
                        if (data !== null && data.data !== null) {
                            const vanStockTransferObj = data.data;
                            vanStockDataNew = {
                                id: vanStockTransferObj.id === null ? "" : vanStockTransferObj.id,
                                transferNo:
                                    vanStockTransferObj.transferNo === null
                                        ? ""
                                        : vanStockTransferObj.transferNo,
                                stockStakeHolderId:
                                    vanStockTransferObj.stockStakeHolderId === null
                                        ? ""
                                        : vanStockTransferObj.stockStakeHolderId,
                                ownerName:
                                    vanStockTransferObj.ownerName === null
                                        ? ""
                                        : vanStockTransferObj.ownerName,
                                firmName:
                                    vanStockTransferObj.firmName === null
                                        ? ""
                                        : vanStockTransferObj.firmName,
                                dataNotPresent: false,
                            };
                        } else {
                            vanStockDataNew = {
                                dataNotPresent: true,
                            };
                        }

                        dispatch(vanStockTransferSuccessNew({ vanStockDataNew }));
                        return { response: vanStockDataNew, success };
                    }
                    return { response: {}, success };
                });
                return response;
            } catch (e) {
                return console.error(e.message);
            }
        };


export const getProductWiseChallanDetails =
    ({ fromDate, toDate }) =>
        async (dispatch) => {
            try {
                const response = apiGet({
                    url: URL + "/product-wise-challan-info-by-dates?fromDate=" + fromDate + "&toDate=" + toDate,
                }).then(({ data, success }) => {
                    if (success) {
                        const row = data.data.map((projectionData, index) => {
                            let projection = {
                                index: index + 1,
                                id: projectionData.id === null ? "" : projectionData.id,
                                productId:
                                    projectionData.productId === null
                                        ? ""
                                        : projectionData.productId,
                                productName:
                                    projectionData.productName !== null
                                        ? projectionData.productName
                                        : "",
                                vanStockTransferProductDetails:
                                    projectionData.vanStockTransferProductDetails !== null
                                        ? projectionData.vanStockTransferProductDetails.map((productDetails, index) => {
                                            return {
                                                index: index + 1,
                                                id: productDetails.id === null ? "" : productDetails.id,
                                                productId: productDetails.productId === null ? "" : productDetails.productId,
                                                product_name: productDetails.product_name === null ? "" : productDetails.product_name,
                                                transferNo: productDetails.transferNo === null ? "" : productDetails.transferNo,
                                                status: productDetails.status === null ? "" : productDetails.status,
                                                driverName: productDetails.driverName === null ? "" : productDetails.driverName,
                                                challanDate: productDetails.challanDate === null ? "" : productDetails.challanDate,
                                                challanQty: productDetails.challanQty === null ? "" : productDetails.challanQty,
                                                headerId: productDetails.headerId === null ? "" : productDetails.headerId,
                                                billQty: productDetails.billQty === null ? "" : productDetails.billQty,
                                                remainingQty: productDetails.remainingQty === null ? "" : productDetails.remainingQty,
                                                headerId: productDetails.headerId === null ? "" : productDetails.headerId,
                                                dtoVanStockTransferOutletDetails: productDetails.dtoVanStockTransferOutletDetails !== null ?
                                                    productDetails.dtoVanStockTransferOutletDetails.map((outletDetails, index) => {
                                                        return {
                                                            index: index + 1,
                                                            id: outletDetails.id === null ? "" : outletDetails.id,
                                                            headerId: outletDetails.headerId === null ? "" : outletDetails.headerId,
                                                            productId: outletDetails.productId === null ? "" : outletDetails.productId,
                                                            outletId: outletDetails.outletId === null ? "" : outletDetails.outletId,
                                                            outletName: outletDetails.outletName === null ? "" : outletDetails.outletName,
                                                            vanStockTrasferHeaderId: outletDetails.vanStockTrasferHeaderId === null ? "" : outletDetails.vanStockTrasferHeaderId,
                                                            billDate: outletDetails.billDate === null ? "" : outletDetails.billDate,
                                                            billQty: outletDetails.billQty === null ? "" : outletDetails.billQty,
                                                        };
                                                    })
                                                    : [],
                                            };
                                        }) : [],
                            };
                            return projection;
                        });
                        return { response: row, success };
                    }
                    return { response: {}, success };
                });
                return response;
            } catch (e) {
                return { response: {}, success: false };
            }
        };

export const getChallanDetailsBwteenDates =
    ({ fromDate, toDate }) =>
        async (dispatch) => {
            try {
                const response = apiGet({
                    url:
                        URL + "/challan-details-between-dates?fromDate=" + fromDate + "&toDate=" + toDate,
                }).then(({ data, success }) => {
                    if (success) {
                        const rowData = data.data;
                        const challanDetailsData = {
                            totalRecords: rowData?.totalRecords ?? "",
                            challanDetails: rowData?.challanDetails.map((dataObj, index) => {
                                const details = {
                                    index: index + 1,
                                    id: dataObj?.id ?? "",
                                    transferNo: dataObj?.transferNo ?? "",
                                    stockStakeHolderId: dataObj?.stockStakeHolderId ?? "",
                                    stockStakeHolderName: dataObj?.stockStakeHolderName ?? "",
                                    date: dataObj?.date ?? "",
                                    statusValue: dataObj?.statusValue ?? "",
                                    status: dataObj?.status ?? "",
                                    driverName: dataObj?.driverName ?? "",
                                    settleDate: dataObj?.settleDate ?? "",
                                    dayDifference: dataObj?.dayDifference ?? "",
                                    beatNames: dataObj?.beatNames ?? "",
                                    qty: dataObj?.qty ?? "",
                                    productCount: dataObj?.productCount ?? "",
                                    progress: dataObj?.progress ?? "",
                                    revenue: dataObj?.revenue.toFixed(2) ?? "",
                                    billCount: dataObj?.billCount ?? "",
                                    challanAmt: dataObj?.challanAmt ?? "",
                                }
                                return details;
                            }) ?? [],
                        }
                        dispatch(vanStockTransferSuccess({ row: challanDetailsData }));
                        return { response: challanDetailsData, success };
                    }
                    return { response: {}, success };
                });
                return response;
            } catch (e) {
                return { response: {}, success: false };
            }
        };

export const getChallanDetailsById =
    ({ challanId }) =>
        async (dispatch) => {
            try {
                const response = apiGet({
                    url:
                        URL + "/challan-info-by-id?challanId=" + challanId,
                }).then(({ data, success }) => {
                    if (success) {
                        const rowData = data.data;
                        const challanDetailsData = {
                            totalRecords: rowData?.totalRecords ?? "",
                            challanDetails: rowData?.challanDetails.map((dataObj, index) => {
                                const details = {
                                    index: index + 1,
                                    id: dataObj?.id ?? "",
                                    transferNo: dataObj?.transferNo ?? "",
                                    stockStakeHolderId: dataObj?.stockStakeHolderId ?? "",
                                    stockStakeHolderName: dataObj?.stockStakeHolderName ?? "",
                                    date: dataObj?.date ?? "",
                                    statusValue: dataObj?.statusValue ?? "",
                                    status: dataObj?.status ?? "",
                                    driverName: dataObj?.driverName ?? "",
                                    settleDate: dataObj?.settleDate ?? "",
                                    dayDifference: dataObj?.dayDifference ?? "",
                                    beatNames: dataObj?.beatNames ?? "",
                                    qty: dataObj?.qty ?? "",
                                    productCount: dataObj?.productCount ?? "",
                                    progress: dataObj?.progress ?? "",
                                    revenue: dataObj?.revenue ?? "",
                                    billCount: dataObj?.billCount ?? "",
                                }
                                return details;
                            }) ?? [],
                            timeline: rowData?.timeline.map((dataObj, index) => {
                                const timelineDetails = {
                                    index: index + 1,
                                    date: dataObj?.date ?? "",
                                    flag: dataObj?.flag ?? "",
                                    label: dataObj?.label ?? "",
                                    state: dataObj?.state ?? "",
                                }
                                return timelineDetails;
                            }) ?? [],
                            inDetailInfo: rowData?.inDetailInfo ?? {},
                        }
                        dispatch(vanStockTransferSuccess({ row: challanDetailsData }));
                        return { response: challanDetailsData, success };
                    }
                    return { response: {}, success };
                });
                return response;
            } catch (e) {
                return { response: {}, success: false };
            }
        };

export const getProductsDetailByChallanHeaderAndProductId =
    ({ headerId, productId }) =>
        async (dispatch) => {
            try {
                const response = apiGet({
                    url: URL + "/get-product-info?headerId=" + headerId + "&productId=" + productId,
                }).then(({ data, success }) => {
                    if (success) {
                        const row = data.data.map((projectionData, index) => {
                            let projection = {
                                index: index + 1,
                                id: projectionData.id === null ? "" : projectionData.id,
                                uuid: projectionData.uuid === null ? "" : projectionData.uuid,
                                activityDate: projectionData.activityDate === null ? "" : projectionData.activityDate,
                                type: projectionData.type === null ? "" : projectionData.type,
                                typeValue: projectionData.typeValue === null ? "" : projectionData.typeValue,
                                amt: projectionData.amt === null ? "" : projectionData.amt.toFixed(2),
                            };
                            return projection;
                        });
                        return { response: row, success };
                    }
                    return { response: [], success };
                });
                return response;
            } catch (e) {
                return { response: [], success: false };

            }
        };

export const getVanDashboardSummary =
    ({ date }) =>
        async () => {
          try {
            const response = apiGet({
              url:
                URLVanDashboard +
                "/get-dashboard-summary?stockStakeHolderId=" +
                "&date=" +
                date,
            }).then(({ data, success }) => {
              if (success) {
                const summaryDataObj = data?.data;
                let summaryData = {
                  id: summaryDataObj?.id === null ? "" : summaryDataObj?.id,
                  totalOrders:
                    summaryDataObj?.totalOrders === null
                      ? ""
                      : summaryDataObj?.totalOrders,
                  challanCreated:
                    summaryDataObj?.challanCreated === null
                      ? ""
                      : summaryDataObj?.challanCreated,
                  challanSettled:
                    summaryDataObj?.challanSetteled === null
                      ? ""
                      : summaryDataObj?.challanSetteled,
                  challanPending:
                    summaryDataObj?.challanPending === null
                      ? ""
                      : summaryDataObj?.challanPending,
                  assignVehicle:
                    summaryDataObj?.assignVehicle === null
                      ? ""
                      : summaryDataObj?.assignVehicle,
                  unassignVehicle:
                    summaryDataObj?.unassignVehicle === null
                      ? ""
                      : summaryDataObj?.unassignVehicle,
                  stockTransferReq:
                    summaryDataObj?.stockTransferReq === null
                      ? ""
                      : summaryDataObj?.stockTransferReq,
                  dispatchQty:
                    summaryDataObj?.dispatchQty === null
                      ? ""
                      : summaryDataObj?.dispatchQty,
                  pendingSettlement:
                    summaryDataObj?.pendingSettlement === null
                      ? ""
                      : summaryDataObj?.pendingSettlement,
                  collectedAmount:
                    summaryDataObj?.collectedAmount === null
                      ? ""
                      : summaryDataObj?.collectedAmount,
                  deliveryRate:
                    summaryDataObj?.deliveryRate === null
                      ? ""
                      : summaryDataObj?.deliveryRate+"%",
                  totalOrdersAmt:
                      summaryDataObj?.totalOrdersAmt === null
                      ? ""
                      : summaryDataObj?.totalOrdersAmt.toFixed(2),
                };
                return { response: summaryData, success };
              }
              return { response: {}, success };
            });
            return response;
          } catch (e) {
            return { response: {}, success: false };
          }
        };

export const getVanDashboardChallanManagement =
    ({ date }) =>
        async () => {
          try {
            const response = apiGet({
              url:
                URLVanDashboard +
                "/get-dashboard-challan-managment?stockStakeHolderId="+"&date=" +date,
            }).then(({ data, success }) => {
              if (success) {
                const challanDataObj = data?.data;
                const statusObj =
                  challanDataObj?.dtoDashboardChallanManagmentStatus;

                const challanStatus = {
                  id: statusObj?.id === null ? "" : statusObj?.id,
                  challanCreated:
                    statusObj?.challanCreated === null
                      ? ""
                      : statusObj?.challanCreated,
                  challanPending:
                    statusObj?.challanPending === null
                      ? ""
                      : statusObj?.challanPending,
                  challanDispatch:
                    statusObj?.challanDispatch === null
                      ? ""
                      : statusObj?.challanDispatch,
                  challanCancel:
                    statusObj?.challanCancel === null
                      ? ""
                      : statusObj?.challanCancel,
                  challanDelivered:
                    statusObj?.challanDelivered === null
                      ? ""
                      : statusObj?.challanDelivered,
                };

                const daySummary = (
                  challanDataObj?.dtoDashboardChallanManagmentDaySummary ?? []
                ).map((dayData) => ({
                  id: dayData?.id === null ? "" : dayData?.id,
                  challanDate:
                    dayData?.challanDate === null ? "" : dayData?.challanDate,
                  dayName: dayData?.dayName === null ? "" : dayData?.dayName,
                  challanCount:
                    dayData?.challanCount === null ? "" : dayData?.challanCount,
                }));

                const recentChallans = (
                  challanDataObj?.dtoDashboardChallanManagmentChallan ?? []
                ).map((challanData, index) => ({
                  index: index + 1,
                  id: challanData?.id === null ? "" : challanData?.id,
                  challanNo:
                    challanData?.challanNo === null ? "" : challanData?.challanNo,
                  challanDate:
                    challanData?.challanDate === null
                      ? ""
                      : challanData?.challanDate,
                  createdTime:
                    challanData?.createdTime === null
                      ? ""
                      : challanData?.createdTime,
                  amount:
                    challanData?.amount === null ? "" : challanData?.amount.toFixed(2),
                  driver:
                    challanData?.driver === null ? "" : challanData?.driver,
                  status:
                    challanData?.status === null ? "" : challanData?.status,
                }));

                return {
                  response: {
                    challanStatus,
                    daySummary,
                    recentChallans,
                  },
                  success,
                };
              }
              return { response: {}, success };
            });
            return response;
          } catch (e) {
            return { response: {}, success: false };
          }
        };

export const getDashboardDriverManagement =
    ({ date }) =>
        async () => {
          try {
            const response = apiGet({
              url:
                URLVanDashboard +
                "/get-dashboard-driver-managment?stockStakeHolderId="+
                "&date=" +
                date,
            }).then(({ data, success }) => {
              if (success) {
                const driverDataObj = data?.data;
                const summaryObj =
                  driverDataObj?.dtoDashboardDriverManagmentSummary;

                const driverSummary = {
                  id: summaryObj?.id === null ? "" : summaryObj?.id,
                  driverOnRoute:
                    summaryObj?.driverOnRoute === null
                      ? ""
                      : summaryObj?.driverOnRoute,
                  vehicleAvailable:
                    summaryObj?.vehicleAvailable === null
                      ? ""
                      : summaryObj?.vehicleAvailable,
                  vehicleLoaded:
                    summaryObj?.vehicleLoaded === null
                      ? ""
                      : summaryObj?.vehicleLoaded,
                  inactiveVehicle:
                    summaryObj?.inactiveVehicle === null
                      ? ""
                      : summaryObj?.inactiveVehicle,
                };

                const driverList = (
                  driverDataObj?.dtoDashboardDriverManagmentList ?? []
                ).map((driverData, index) => ({
                  index: index + 1,
                  id: driverData?.id === null ? "" : driverData?.id,
                  name: driverData?.name === null ? "" : driverData?.name,
                  assignedChallan:
                    driverData?.assignedChallan === null
                      ? ""
                      : driverData?.assignedChallan,
                  activeChallan:
                      driverData?.activeChallan === null
                        ? ""
                        : driverData?.activeChallan,
                  settledChallan:
                    driverData?.settledChallan === null
                      ? ""
                      : driverData?.settledChallan,
                  pendingChallan:
                    driverData?.pendingChallan === null
                      ? ""
                      : driverData?.pendingChallan,
                  activeChallan:
                    driverData?.activeChallan === null
                      ? ""
                      : driverData?.activeChallan,
                }));

                return {
                  response: {
                    driverSummary,
                    driverList,
                  },
                  success,
                };
              }
              return { response: {}, success };
            });
            return response;
          } catch (e) {
            return { response: {}, success: false };
          }
        };

export const getDashboardStockManagement =
    ({ date }) =>
        async () => {
          try {
            const response = apiGet({
              url:
                URLVanDashboard +
                "/get-dashboard-stock-managment?stockStakeHolderId=" +
                "&date=" +
                date,
            }).then(({ data, success }) => {
              if (success) {
                const stockDataObj = data?.data;
                const summaryObj =
                  stockDataObj?.dtoDashboardStockManagmentSummary;

                const stockSummary = {
                  id: summaryObj?.id === null ? "" : summaryObj?.id,
                  total:
                    summaryObj?.total === null ? "" : summaryObj?.total,
                  approved:
                    summaryObj?.approved === null ? "" : summaryObj?.approved,
                  inTransaction:
                    summaryObj?.inTransaction === null
                      ? ""
                      : summaryObj?.inTransaction,
                  outTransaction:
                    summaryObj?.outTransaction === null
                      ? ""
                      : summaryObj?.outTransaction,
                };

                const stockList = (
                  stockDataObj?.dtoDashboardStockManagmentList ?? []
                ).map((stockData, index) => ({
                  index: index + 1,
                  id: stockData?.id === null ? "" : stockData?.id,
                  challanNo:
                    stockData?.challanNo === null ? "" : stockData?.challanNo,
                  challanDate:
                    stockData?.challanDate === null
                      ? ""
                      : stockData?.challanDate,
                  salesTeamName:
                      stockData?.salesTeamName === null
                        ? ""
                        : stockData?.salesTeamName,
                  inOutStatus:
                    stockData?.inOutStatus === null
                      ? ""
                      : stockData?.inOutStatus,
                  productCount:
                    stockData?.productCount === null
                      ? ""
                      : stockData?.productCount,
                  productQuantity:
                    stockData?.productQuantity === null
                      ? ""
                      : stockData?.productQuantity,
                  productAmount:
                    stockData?.productAmount === null
                      ? ""
                      : stockData?.productAmount,
                }));

                return {
                  response: {
                    stockSummary,
                    stockList,
                  },
                  success,
                };
              }
              return { response: {}, success };
            });
            return response;
          } catch (e) {
            return { response: {}, success: false };
          }
        };

export const getVanDashboardChallanSettlement =
    ({ date }) =>
        async () => {
          try {
            const response = apiGet({
              url:
                URLVanDashboard +
                "/get-dashboard-challan-settlement?stockStakeHolderId=" +
                "&date=" +
                date,
            }).then(({ data, success }) => {
              if (success) {
                const settlementDataObj = data?.data;
                const summaryObj =
                  settlementDataObj?.dtoDashboardChallanSettlementSummary;

                const settlementSummary = {
                  id: summaryObj?.id === null ? "" : summaryObj?.id,
                  totalSettledAmt:
                    summaryObj?.totalSettledAmt === null
                      ? ""
                      : summaryObj?.totalSettledAmt,
                  totalDispatchAmt:
                    summaryObj?.totalDispatchAmt === null
                      ? ""
                      : summaryObj?.totalDispatchAmt,
                  overdueAmount:
                    summaryObj?.overdueAmount === null
                      ? ""
                      : summaryObj?.overdueAmount,
                };

                const settlementList = (
                  settlementDataObj?.dtoDashboardChallanSettlementList ?? []
                ).map((settlementData, index) => ({
                  index: index + 1,
                  id: settlementData?.id === null ? "" : settlementData?.id,
                  date:
                    settlementData?.date === null ? "" : settlementData?.date,
                  name:
                    settlementData?.name === null ? "" : settlementData?.name,
                  amount:
                    settlementData?.amount === null
                      ? ""
                      : settlementData?.amount,
                  daysPending:
                    settlementData?.daysPending === null
                      ? ""
                      : settlementData?.daysPending,
                  urgency:
                    settlementData?.urgency === null
                      ? ""
                      : settlementData?.urgency,
                }));

                return {
                  response: {
                    settlementSummary,
                    settlementList,
                  },
                  success,
                };
              }
              return { response: {}, success };
            });
            return response;
          } catch (e) {
            return { response: {}, success: false };
          }
        };

